const MOBILE_BREAKPOINT = 920;

const selectors = {
    toggle: '#menuToggle',
    sidebar: '#sidebar',
    overlay: '#sidebarOverlay',
    close: '#sidebarCloseBtn'
};

const isMobileLayout = () => window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches;

const getElements = () => ({
    toggle: document.querySelector(selectors.toggle),
    sidebar: document.querySelector(selectors.sidebar),
    overlay: document.querySelector(selectors.overlay)
});

const updateToggleState = (isExpanded) => {
    const { toggle } = getElements();

    if (!toggle) {
        return;
    }

    toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
};

const setSidebarState = (isOpen) => {
    const { sidebar, overlay } = getElements();

    if (!sidebar || !overlay) {
        return;
    }

    if (!isMobileLayout()) {
        sidebar.classList.remove('show');
        overlay.classList.remove('show');
        document.body.classList.remove('sidebar-open');
        updateToggleState(false);
        return;
    }

    sidebar.classList.remove('tw-hidden');
    sidebar.classList.toggle('show', isOpen);
    overlay.classList.toggle('show', isOpen);
    document.body.classList.toggle('sidebar-open', isOpen);
    updateToggleState(isOpen);
};

const toggleSidebar = () => {
    const { sidebar } = getElements();

    if (!sidebar || !isMobileLayout()) {
        return;
    }

    setSidebarState(!sidebar.classList.contains('show'));
};

const closeSidebar = () => {
    if (!isMobileLayout()) {
        return;
    }

    setSidebarState(false);
};

const shouldCloseAfterClick = (target) => {
    if (!isMobileLayout()) {
        return false;
    }

    if (target.closest('[data-sidebar-workspace-trigger]')) {
        return false;
    }

    return Boolean(
        target.closest('#sidebar a') ||
        target.closest('#sidebar .project-item') ||
        target.closest('#sidebar .project-sub-item') ||
        target.closest('#sidebar .workspace-menu-item')
    );
};

const registerSidebarEvents = () => {
    document.addEventListener('click', (event) => {
        if (event.target.closest(selectors.toggle)) {
            event.preventDefault();
            toggleSidebar();
            return;
        }

        if (event.target.closest(selectors.close) || event.target.closest(selectors.overlay)) {
            event.preventDefault();
            closeSidebar();
            return;
        }

        if (shouldCloseAfterClick(event.target)) {
            closeSidebar();
        }
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            closeSidebar();
        }
    });

    let resizeTimer;

    window.addEventListener('resize', () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(() => {
            setSidebarState(false);
        }, 100);
    });
};

const initSidebar = () => {
    setSidebarState(false);
    registerSidebarEvents();
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSidebar, { once: true });
} else {
    initSidebar();
}
